function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.71252 6.70507L11.7047 1.7192C12.0984 1.32595 12.0984 0.688175 11.7047 0.294932C11.311 -0.0983107 10.6724 -0.0983107 10.2786 0.294932L5.99999 4.56821L1.72136 0.294932C1.32762 -0.0983107 0.689042 -0.0983107 0.295304 0.294932C-0.0984344 0.688175 -0.0984344 1.32595 0.295304 1.7192L5.28746 6.70507C5.68022 7.09831 6.31878 7.09831 6.71252 6.70507Z"
});

const SvgDownArrow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 7,
  viewBox: "0 0 12 7",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/downArrow.220caf0a.svg";
export { ForwardRef as ReactComponent };